import { sessionStorageKeyConstants } from '../../../constants/session-storage-key-constants'
import { getHeaders } from '../../axios/axios-helpers'
import HttpClient from '../../axios/http-client'

export async function createTableauUser(username, siteRole) {
  const apiPath = `tableau/create?username=${username}&siteRole=${siteRole}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.reportingInstance().post(apiPath)
}
